import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, Redirect } from 'react-router-dom'
import { Spin, Row, Col, Button, Input, Modal, Radio } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import util from '../../util/util'
import { User } from '../../component'
import '../../css/users.scss'
import { useLocation } from 'react-router'
import { fetchUsers } from '../../store/action/user.action'
import { messageGroupBy } from '../../store/action/actioncases.action'
import { getHelp, pages } from '../../tutorials'
var { Search } = Input
var { Table } = User

const Users = (props) => {
  const location = useLocation()
  console.log('======>loaction', props, location)
  var handleSearch = (value) => {
    props.fetchUsers({
      customerid: props.customer?._id,
      pagination: { current: 1, pageSize: 20 },
      searchText: value,
      sorter: { order: 'ascend', field: 'surgery' },
      active: props.active,
      onlyusers: true,
    })
  }

  var handleChange = ({ target }) => {
    props.fetchUsers({
      customerid: props.customer?._id,
      pagination: { current: 1, pageSize: 20 },
      searchText: props.searchText,
      sorter: { order: 'ascend', field: 'surgery' },
      active: target.value,
      onlyusers: true,
    })
  }
  useEffect(() => {
    props.messageGroupBy(null)
    getHelp(pages.USERLIST)
  }, [])
  return props.token == undefined ? (
    <Redirect to='/login' />
  ) : (
    <>
      <Spin spinning={props.isLoading}>
        <Col className='userContainer'>
          <Row className={'actionRow'} justify={'end'}>
            <Col flex={'60%'} style={{ marginRight: 'auto' }}>
              <Row className={'headerText'} gutter={20} align={'middle'}>
                <Col flex={'40px'}> USERS </Col>
                <Col flex={'auto'}>
                  <Search
                    id={'searchuser'}
                    className='surgeonSearch'
                    onSearch={handleSearch}
                    defaultValue={props.searchText}
                  />
                </Col>
              </Row>
            </Col>
            <Col>
              <Row justify={'end'} align={'bottom'}>
                <Radio.Group
                  id={'userstatusfilter'}
                  buttonStyle='solid'
                  onChange={handleChange}
                  value={props.active}
                >
                  <Radio.Button value={true}>Active</Radio.Button>
                  <Radio.Button value={false}>Inactive</Radio.Button>
                </Radio.Group>
              </Row>
            </Col>
            <Col style={{ marginLeft: 10 }}>
              <Row justify={'end'} align={'bottom'}>
                <Button id={'adduser'} className={'actionBtn'}>
                  <Link to={(props.back || 'users') + '/add'}> ADD </Link>
                </Button>
              </Row>
            </Col>
          </Row>
          <Table back={props.back || '/users'} />
        </Col>
      </Spin>
    </>
  )
}

Users.propTypes = {
  isLoading: PropTypes.bool,
  token: PropTypes.string.isRequired,
  deleteSurgeons: PropTypes.func.isRequired,
  pagination: PropTypes.object,
  sorter: PropTypes.object,
  searchText: PropTypes.string,
  active: PropTypes.bool,
  path: PropTypes.string,
}

const mapStateToProps = (state) => {
  return {
    token: util.verifyToken(state.profile.token),
    isLoading: state.profile.isLoading,
    customer: state.profile.customer,
    successMessage: state.profile.successMessage,
    pagination: state.user.pagination,
    searchText: state.user.searchText,
    active: state.user.active,
    sorter: state.user.sorter,
    company: state.profile.company,
    user: state.profile.user,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    messageGroupBy: (data) => dispatch(messageGroupBy(data)),
    fetchUsers: (params) => dispatch(fetchUsers(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users)
